export default {
  'editorial-staff': 'A nossa redação',
  'published-on': 'Publicado em',
  'read-articles': 'Leia os seus artigos',
  'about-author': 'Sobre o autor',
}
